export default __webpack_public_path__ + "static/media/bird-bullfinch-animated-moving.70a382be.svg";